// The backend stores every status/type/category/stage as a bare number with no
// meaning of its own. These maps are the single frontend contract for those codes.

export const BRAND_CATEGORY = {
  1: "Women's Ethnic",
  2: "Contemporary Women's",
  3: 'Luxury Formals',
  4: 'Streetwear',
  5: 'Contemporary Apparel',
  6: 'Menswear',
  7: 'Kidswear',
};

export const PARTNER_STATUS = ['Active', 'Onboarding', 'Suspended'];
export const ONBOARDING_STATUS = ['Complete', 'Incomplete'];
export const USER_STATUS = ['Active', 'Suspended'];

export const ENGAGEMENT_STATUS = {
  1: 'Active',
  2: 'Onboarding',
  3: 'Suspended',
  4: 'Closed',
};

export const WORKFLOW_STAGE = {
  1: 'Backlog',
  2: 'Requirement',
  3: 'Fabric Sourcing',
  4: 'Fabric Approval',
  5: 'Design Charge',
  6: 'Design In Progress',
  7: 'Design Approval',
  8: 'Sampling',
  9: 'Sample Approval',
  10: 'Order Placed',
  11: 'In Production',
  12: 'Ready',
  13: 'Dispatched',
  14: 'Delivered',
  15: 'Done',
};

export const ENGAGEMENT_STAGE = { 0: 'Onboarding', ...WORKFLOW_STAGE };

export const LEDGER_TYPE = {
  1: 'OPENING',
  2: 'RECHARGE',
  3: 'DEBIT',
  4: 'HOLD',
  5: 'RELEASE',
  6: 'REVERSAL',
  7: 'ADJUSTMENT',
};

export const LEDGER_CATEGORY = {
  1: 'Opening Balance',
  2: 'Payment Receipt',
  3: 'Design Charge',
  4: 'Fabric Procurement',
  5: 'Sampling',
  6: 'Order',
  7: 'Production',
  8: 'Logistics',
  9: 'Reversal',
  10: 'Other',
};

export const LEDGER_STATUS = {
  1: 'Posted',
  2: 'Active Hold',
  3: 'Released',
  4: 'Pending',
  5: 'Historical',
};

export const LEDGER_APPROVAL = {
  1: 'N/A',
  2: 'Pending',
  3: 'Pending Acknowledgement',
  4: 'Acknowledged',
  5: 'Rejected',
};

export const PAYMENT_MODE = {
  1: 'Bank Transfer',
  2: 'NEFT',
  3: 'RTGS',
  4: 'IMPS',
  5: 'UPI',
  6: 'Cheque',
  7: 'Cash',
};

export const RECEIPT_STATUS = {
  1: 'Draft',
  2: 'Submitted',
  3: 'Under Review',
  4: 'Needs More Information',
  5: 'Approved',
  6: 'Posted to Wallet',
  7: 'Rejected',
};

export const REQUIREMENT_STATUS = {
  1: 'Draft',
  2: 'Submitted',
  3: 'Under Review',
  4: 'Clarification Required',
  5: 'Accepted',
  6: 'Rejected',
  7: 'Completed',
  8: 'Cancelled',
};

export const REQUIREMENT_CATEGORY = {
  1: 'Tops',
  2: 'Shirts',
  3: 'Sets',
  4: 'Ethnic',
  5: 'Outerwear',
  6: 'Blazers',
  7: 'Dresses',
  8: 'Bottoms',
  9: 'Other',
};

export const GARMENT_TYPE = {
  1: 'Shirt',
  2: 'T-Shirt',
  3: 'Co-ord Set',
  4: 'Kurta',
  5: 'Overshirt',
  6: 'Blazer',
  7: 'Dress',
  8: 'Trousers',
  9: 'Skirt',
  10: 'Jacket',
  11: 'Other',
};

export const PRIORITY = { 1: 'High', 2: 'Medium', 3: 'Low' };

export const FABRIC_DECISION = {
  1: 'Draft',
  2: 'Submitted to Brand',
  3: 'Under Brand Review',
  4: 'Approved',
  5: 'Rejected',
  6: 'More Options Requested',
};

export const SWATCH_STATUS = {
  1: 'Not Dispatched',
  2: 'In Transit',
  3: 'Dispatched',
  4: 'Received',
};

export const DESIGN_STATUS = {
  1: 'Awaiting Brand Approval',
  2: 'Design In Progress',
  3: 'Submitted for Approval',
  4: 'Revision Requested',
  5: 'Approved',
  6: 'Finalised',
};

export const CHARGE_STATUS = {
  1: 'Charge Pending',
  2: 'Charge Approved',
  3: 'Rejected',
};

export const FINALISATION_STATUS = {
  1: 'Not Started',
  2: 'In Progress',
  3: 'Awaiting Brand Review',
  4: 'Finalised',
};

export const DESIGN_VERSION_STATUS = {
  1: 'Pending Review',
  2: 'Revision Requested',
  3: 'Approved',
};

export const ORDER_STATUS = {
  1: 'Draft',
  2: 'Submitted',
  3: 'Estimate Pending',
  4: 'Estimate Approved',
  5: 'Confirmed',
  6: 'In Production',
  7: 'Ready',
  8: 'Dispatched',
  9: 'Delivered',
  10: 'Cancelled',
};

export const ORDER_RECEIPT_STATUS = {
  1: 'Pending',
  2: 'Confirmed',
  3: 'Disputed',
};

export const WAITING_ON = { 1: 'Brand', 2: 'Manufacturer' };

export const TASK_TYPE = {
  1: 'Requirement',
  2: 'Fabric sourcing',
  3: 'Fabric approval',
  4: 'Design charge',
  5: 'Design development',
  6: 'Design approval',
  7: 'Sampling',
  8: 'Order',
  9: 'Production',
  10: 'Dispatch',
  11: 'Delivery',
};

export const DOCUMENT_CATEGORY = {
  1: 'Design source files',
  2: 'Fabric quotations',
  3: 'Payment screenshots',
  4: 'Purchase invoices',
  5: 'Brand profile documents',
  6: 'Measurement sheets',
  7: 'Tech packs',
  8: 'Other',
};

export const DOCUMENT_VISIBILITY = {
  1: 'Shared',
  2: 'Brand only',
  3: 'Manufacturer only',
};

export const NOTIFICATION_TYPE = {
  1: 'payment_receipt',
  2: 'low_balance',
  3: 'design_approval',
  4: 'receipt_confirmed',
  5: 'fabric_approved',
  6: 'task_overdue',
  7: 'design_version_submitted',
  8: 'fabric_submitted',
  9: 'design_charge_submitted',
  10: 'adjustment_pending',
  11: 'order_update',
  12: 'clarification_requested',
  13: 'payment_receipt_under_review',
};

export const USER_ROLE = {
  0: 'System',
  1: 'Manufacturer Admin',
  2: 'Manufacturer Coordinator',
  3: 'Designer',
  4: 'Brand Owner',
  5: 'Brand Operations',
};

const LINKED_ITEM_ROUTE = {
  PaymentReceipt: 'receipts',
  LedgerEntry: 'wallets',
  FabricOption: 'fabrics',
  Design: 'designs',
  Order: 'orders',
  Requirement: 'requirements',
  WorkflowTask: 'board',
  Engagement: 'engagements',
};

// Page that owns a linked item, per workspace ('/dashboard' or '/brand'); null when there is none.
export const linkedItemPath = (basePath, linkedItemType) => {
  const route = LINKED_ITEM_ROUTE[linkedItemType];
  if (!route) return null;
  return `${basePath}/${basePath === '/brand' && route === 'wallets' ? 'wallet' : route}`;
};

export const label = (map, code, fallback = '—') => {
  if (code === null || code === undefined || code === '') return fallback;
  return map[code] ?? fallback;
};

export const options = (map) =>
  Object.entries(map).map(([value, text]) => ({ value: Number(value), label: text }));

export const toCode = (value) => (value === '' || value === null || value === undefined ? undefined : Number(value));

export const today = () => new Date().toISOString().slice(0, 10);

export const formatINR = (n) => '₹' + (Number(n) || 0).toLocaleString('en-IN');

export const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
};

export const initials = (name = '') =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() || '')
    .join('') || '—';
